const config = {
  // Local development settings
  // apiBaseUrl: 'http://127.0.0.1:8000/api',
  // imageBaseUrl: 'http://127.0.0.1:8000',
  // frontend_url: "http://localhost:3000",

  // Production settings
  apiBaseUrl: 'https://accupricelists.com/api',
  imageBaseUrl: 'https://accupricelists.com',
  frontend_url: "https://accupricelists.com",

  // variables
  quickbook_clientid: 'ABVsaw4X0vspP3qygzBncEABQazUCfV8BoyDYsjNwStY05fyJu', // production
  // quickbook_clientid: 'ABNpcDHw0gUzM9sCbcOg0Z2eUI0mxyP9ut3XoRZPMLUfDIKuP6', // sandbox
  
  // Jobber configuration
  jobber_clientid: '91e312a9-0098-4d5a-8866-28b0ddf6302b',
};

export default config;
